import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  ogUrl?: string;
  canonical?: string;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords,
  ogImage = '/images/og-image.jpg',
  ogUrl,
  canonical,
}) => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  
  const defaultTitle = t('seo.defaultTitle', 'LunaNüva | Analyse et interprétation de rêves');
  const defaultDescription = t('seo.defaultDescription', 'Explorez la richesse de vos rêves grâce aux méthodes d\'analyse les plus reconnues. Notre application s\'appuie sur les travaux des plus grands théoriciens en psychologie des rêves.');
  const defaultKeywords = t('seo.defaultKeywords', 'analyse rêves, interprétation rêves, journal des rêves, psychologie des rêves');
  
  const siteUrl = window.location.origin;
  const currentUrl = window.location.href;

  return (
    <Helmet>
      {/* Balises de base */}
      <html lang={currentLang} />
      <title>{title || defaultTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      
      {/* Balises canoniques */}
      <link rel="canonical" href={canonical || currentUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={ogUrl || currentUrl} />
      <meta property="og:title" content={title || defaultTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={`${siteUrl}${ogImage}`} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={ogUrl || currentUrl} />
      <meta name="twitter:title" content={title || defaultTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content={`${siteUrl}${ogImage}`} />
    </Helmet>
  );
};

export default SEO;